var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8479 2.27788C6.90763 2.27788 2.09209 7.09342 2.09209 13.0337C2.09209 18.974 6.90762 23.7895 12.8479 23.7895C18.7882 23.7895 23.6037 18.974 23.6037 13.0337C23.6037 7.09342 18.7882 2.27788 12.8479 2.27788ZM0.3479 13.0337C0.3479 6.13013 5.94434 0.533691 12.8479 0.533691C19.7515 0.533691 25.3479 6.13013 25.3479 13.0337C25.3479 19.9373 19.7515 25.5337 12.8479 25.5337C5.94434 25.5337 0.3479 19.9373 0.3479 13.0337ZM12.9512 6.63834C9.41914 6.63834 6.55585 9.50165 6.55585 13.0337H4.81167C4.81167 8.53835 8.45585 4.89416 12.9512 4.89416V6.63834ZM12.9512 19.429C16.4833 19.429 19.3466 16.5657 19.3466 13.0337H21.0908C21.0908 17.529 17.4466 21.1732 12.9512 21.1732V19.429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokens);
export default __webpack_public_path__ + "static/media/tokens.dcad28c2ad4ccca37b66d7a3316c64c0.svg";
export { ForwardRef as ReactComponent };